<template>
  <div class="row products">
    <div v-if="!showForm()" class="col-xl-12 col-md-12 col-xs-12">
      <div class="card mar-to-15 tableInvoice">
        <div class="card-content">

          <!-- LOADING OVERLAY -->
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg>
            </div>
          </div>

          <!-- TOP BAR -->
          <div class="table-top" ref="tableTop" style="display: flex; justify-content: space-between;align-items: flex-start;gap: 10px;flex-wrap: wrap;flex-direction: column;">

            <!-- LEFT: FILTERS + SEARCH -->
            <div class="left-group" style="display: flex; flex-wrap: wrap; gap: 8px; align-items: flex-end; flex: 1 1 auto;">

              <!-- SEARCH -->
              <div class="form-group" style="flex: 1 1 200px; margin: 0;">
                <label>{{ $t('catalogProd.search') }}</label>
                <el-input
                  v-model="search"
                  :placeholder="$t('catalogProd.search')"
                  size="small"
                  clearable
                />
              </div>

              <!-- ID -->
              <div class="form-group" style="flex: 0 0 120px; margin: 0;">
                <label>{{ $t('catalogProd.id') }}</label>
                <el-input
                  v-model="searchId"
                  :placeholder="$t('catalogProd.id')"
                  size="small"
                  clearable
                />
              </div>

              <!-- STATUS -->
              <div class="form-group" style="flex: 0 0 120px; margin: 0;">
                <label>{{ $t('orders.status') }}</label>
                <v-select
                  v-model="filters[3].value"
                  :options="[
                    { id: 'active', type: $t('general.active') },
                    { id: 'inactive', type: $t('general.inactive') }
                  ]"
                  multiple
                  label="type"
                  :reduce="option => option.id"
                  :placeholder="$t('general.select')"
                  clearable
                ></v-select>
              </div>

              <!-- TOP CATEGORY -->
              <div class="form-group" v-if="topCategories.length" style="flex: 0 0 140px; margin: 0;">
                <label>{{ $t('catalogProd.topCategory') }}</label>
                <v-select
                  v-model="filters[5].value"
                  :options="topCategories"
                  multiple
                  label="name"
                  :reduce="cat => cat.id"
                  :placeholder="$t('general.select')"
                  clearable
                ></v-select>
              </div>

              <!-- CATEGORY -->
              <div class="form-group" v-if="mainCategories.length" style="flex: 0 0 140px; margin: 0;">
                <label>{{ $t('catalogProd.category') }}</label>
                <v-select
                  v-model="filters[1].value"
                  :options="mainCategories"
                  multiple
                  label="name"
                  :reduce="cat => cat.id"
                  :placeholder="$t('general.select')"
                  clearable
                ></v-select>
              </div>

              <!-- LOCATIONS -->
              <!-- {{ filters[2].value }} -->
              <div class="form-group" v-if="locations.length" style="flex: 0 0 140px; margin: 0;">
                <label>{{ $t('orders.location') }}</label>
                <v-select
                  v-model="filters[2].value"
                  :options="locations"
                  multiple
                  label="name"
                  :reduce="loc => loc.id"
                  :placeholder="$t('general.select')"
                  clearable
                ></v-select>
              </div>

              <!-- SPECIAL PRICE -->
              <div class="form-group" style="flex: 0 0 120px; margin: 0;">
                <label>{{ $t('general.specialPrice') }}</label>
                <v-select
                  v-model="filters[4].value"
                  :options="[
                    { id: 'discounted', type: $t('general.active') },
                    { id: 'notDiscounted', type: $t('general.inactive') }
                  ]"
                  multiple
                  label="type"
                  :reduce="option => option.id"
                  :placeholder="$t('general.select')"
                  clearable
                ></v-select>
              </div>

              <!-- DELIVERY METHOD -->
              <div class="form-group" style="flex: 0 0 210px; margin: 0;">
                <label>{{ $t('catalogProd.deliveryMethod') }}</label>
                <v-select
                  v-model="filters[6].value"
                  :options="[
                    { id: 'delivery', type: $t('settingCompany.delivery') },
                    { id: 'eat_location', type: $t('settingCompany.eat_location') },
                    { id: 'meet_half', type: $t('settingCompany.meet_half') },
                    { id: 'pick_up', type: $t('settingCompany.pick_up') },
                    { id: 'self_ordering', type: $t('settingCompany.self_ordering') }
                  ]"
                  multiple
                  label="type"
                  :reduce="option => option.id"
                  :placeholder="$t('general.select')"
                  clearable
                  :close-on-select="false"
                ></v-select>
              </div>

              <!-- SEARCH BUTTON -->
              <div class="form-group" style="flex: 0 0 100px; margin: 0;">
                <button class="btn add" @click="applyFilters" :title="$t('reports.search')" style="width: 100%; font-size: 12px; padding: 4px 8px;">
                  <i class="ti-search"></i> {{ $t('general.search') }}
                </button>
              </div>

            </div>

            <!-- RIGHT: ACTIONS -->
            <div class="right-group" style="flex: 0 0 auto; margin-bottom: 20px; margin-top: 10px; display: flex; gap: 8px; flex-wrap: wrap;">
              <button
                class="btn add"
                @click.prevent="openMassUpdateModal"
                :disabled="affectedProductCount <= 0"
                :title="$t('catalogProd.massUpdate')"
                style="font-size: 12px; padding: 4px 8px;"
              >
                {{ $t('catalogProd.massUpdate') }}
                <span v-if="affectedProductCount > 0">({{ affectedProductCount }})</span>
              </button>
              <button class="btn add" @click.prevent="goToAdd" :title="$t('general.add') + ' ' + $t('catalogProd.single')" style="font-size: 12px; padding: 4px 8px;">
                <img src="/static/img/icons/icon-plus-sm.png" /> {{ $t('general.add') }} {{ $t('catalogProd.single') }}
              </button>
            </div>

          </div>

          <!-- TABLE -->
          <div v-if="!showForm()" class="data-table" style="margin-top: 20px;">
            <el-table :data="tableData" :row-class-name="rowClass" :empty-text="$t('gestiune.noData')" style="width: 100%;" @row-click="onRowClick">
              <el-table-column width="50" class-name="selection-column" align="center">
                <template slot="header" slot-scope="scope">
                  <input
                    type="checkbox"
                    class="product-select-checkbox"
                    :checked="headerCheckboxChecked"
                    :indeterminate.prop="headerCheckboxIndeterminate"
                    @click.stop.prevent="toggleSelectAll"
                  />
                </template>
                <template slot-scope="scope">
                  <input
                    type="checkbox"
                    class="product-select-checkbox"
                    :checked="isProductSelected(scope.row.id)"
                    @click.stop="toggleProductSelection(scope.row.id)"
                  />
                </template>
              </el-table-column>
              <el-table-column prop="id" :label="$t('catalogProd.id')" width="80"/>
              <el-table-column prop="name" :label="$t('catalogProd.name')"/>
              <el-table-column prop="active" :label="$t('general.active')">
                <template slot-scope="scope">
                  <div @click.stop>
                    <p-switch
                      v-if="scope.row.allowed_location"
                      v-model="scope.row.active"
                      type="success"
                      @input="checkBanner(scope.$index, scope.row, $event)"
                    />
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="category" :label="$t('catalogProd.category')"/>
              <el-table-column prop="price" :label="$t('catalogProd.price')">
                <template slot-scope="scope">
                  <input
                    v-if="showLocations"
                    type="number"
                    class="form-control"
                    v-model="scope.row.price"
                    :disabled="(!scope.row.allowed_location && !scope.row.is_discounted)"
                    :readonly="scope.row.is_discounted"
                    @click.stop
                    @focus.stop
                  />
                  <b v-else>
                    {{ scope.row.price_details ? decodeHtml(scope.row.price_details.formatted_price) : '' }}
                  </b>
                  <button
                    v-if="scope.row.allowed_location && !scope.row.is_discounted"
                    style="margin-left: 5px; margin-bottom: 2px;"
                    class="btn btn-success btn-icon mar-to-5"
                    @click.stop="updateName(scope.$index, scope.row, $event)">
                    <i class="ti-save"></i>
                  </button>
                </template>
              </el-table-column>

              <el-table-column prop="locations" :label="$t('orders.location')">
                <template slot-scope="scope">
                  <div class="locations-scroll-horizontal">
                    <template v-if="scope.row.locations && Object.keys(scope.row.locations).length">
                      <span
                        v-for="(locName, locKey) in scope.row.locations"
                        :key="locKey"
                        class="location-item"
                      >
                        {{ locName }}
                      </span>
                    </template>
                    <span v-else class="location-item">
                      {{$t('general.all')}}
                    </span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column :label="$t('general.actions')" width="120">
                <template slot-scope="scope">
                  <el-dropdown trigger="click" placement="bottom-end" @click.native.stop>
                    <span class="arrow-box">&#9662;</span>
                    <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                      <el-dropdown-item @click.native.stop="goToRecord(scope.row, null, $event)">
                        {{$t('general.edit')}}
                      </el-dropdown-item>
                      <el-dropdown-item @click.native.stop="duplicateProduct(scope.$index, scope.row, $event)">
                        {{$t('general.duplicate')}}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>

            <!-- PAGINATION -->
            <el-pagination
              layout="prev, pager, next"
              :total="paginationDef.totalRecords"
              :page-size="paginationDef.perPage"
              :current-page.sync="paginationDef.page"
              @current-change="handlePageChange"
              style="margin-top: 15px; text-align: right;"
            />
          </div>

        </div>
      </div>
    </div>

    <!-- <template v-if="allowedOnProductLocation">
      <div class="prod-top-bar col-ms-12"ref="prodTopBar" v-if="showForm()">
        <h6 class="pull-left"><img src="/static/img/icons/feather-edit.png">{{type}} {{$t('catalogProd.single')}}</h6>
        <div class="text-right">
          <p class="">
            <button type="submit" @click.prevent="validate" class="btn btn-icon btn-success btn mar-rt-10 save" :title="$t('general.save')">
              <img src="/static/img/icons/save.png">
              {{$t('general.save')}}
            </button>
            <a v-if="isNew()" @click.prevent="handleDelete('cancel')" class="btn btn-danger btn-icon btn btn mar-rt-10 delete" :title="$t('general.cancel')"><img src="/static/img/icons/icon-close.png"> {{ $t('general.cancel') }}</a>
            <a v-else @click.prevent="handleDelete('delete this product')" class="btn btn-danger btn-icon btn btn mar-rt-10 delete" :title="$t('general.delete') + ' ' + $t('catalogProd.single')">
              <img src="/static/img/icons/icon-close.png">
              {{$t('general.delete')}}
            </a>
          </p>
        </div>
      </div>
    </template> -->

    <!-- <div v-if="showForm()" class="col-md-12" ref="detailsScroll" >
      <template>
        <product-form
          v-show="loaded"
          ref="prodForm"
          :mainCategoriesParent="mainCategories"
          :taxesParent="taxes"
          :kdsSectionsParent="kdsSections"
          :productOptionsParent="productOptions"
          :companyProductFilters="companyProductFilters"
          :measurementsUnits="measurementsUnits"
          :language="language"
          :languages="languages"
          :callback="updateList"
          :callbackDelete="getProducts"
        ></product-form>
      </template>
    </div> -->

    <!-- MASS UPDATE MODAL -->
    <div v-if="showMassUpdateModal" class="modal-overlay">
      <div class="modal-dialog mass-update-modal">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">
              {{ $t('catalogProd.massUpdate') }}
              <span class="mass-count-badge">({{ affectedProductCount }})</span>
            </h4>
            <p class="mass-subtitle">{{ $t('catalogProd.massUpdateSubtitle', { count: affectedProductCount }) }}</p>
            <button type="button" class="close" @click="closeMassUpdateModal">
              <i class="ti-close"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="mass-action-pills">
              <button
                v-for="opt in massActionOptions"
                :key="opt.id"
                type="button"
                class="mass-action-pill"
                :class="{
                  active: massAction === opt.id,
                  danger: opt.id === 'delete',
                  queued: isMassActionQueued(opt.id)
                }"
                @click="massAction = opt.id"
              >
                <i v-if="isMassActionQueued(opt.id)" class="ti-check mass-pill-check"></i>
                {{ opt.label }}
              </button>
            </div>

            <!-- LOCATIONS -->
            <div v-if="massAction === 'locations'" :key="'panel-locations'" class="mass-action-panel">
              <div class="form-group">
                <label>{{ $t('orders.location') }}</label>
                <el-select
                  :key="'select-locations'"
                  v-model="bulkLocationTokens"
                  multiple
                  collapse-tags
                  filterable
                  clearable
                  style="width: 100%"
                  :placeholder="$t('general.select')"
                >
                  <el-option
                    v-for="loc in locations"
                    :key="'loc-' + (loc.token || loc.id)"
                    :label="loc.name"
                    :value="loc.token"
                  />
                </el-select>
              </div>
              <div class="form-group">
                <label>{{ $t('catalogProd.bulkLocationsMode') }}</label>
                <el-select
                  :key="'select-locations-mode'"
                  v-model="bulkLocationMode"
                  style="width: 100%"
                  :placeholder="$t('general.select')"
                >
                  <el-option
                    v-for="opt in bulkModeOptions"
                    :key="'loc-mode-' + opt.id"
                    :label="opt.label"
                    :value="opt.id"
                  />
                </el-select>
              </div>
              <div class="form-group">
                <p-switch v-model="bulkIncludeAllLocations" type="primary"></p-switch>
                <label class="switch-label">{{ $t('catalogProd.includeAllLocationsProducts') }}</label>
              </div>
            </div>

            <!-- ACTIVE -->
            <div v-else-if="massAction === 'set_active'" :key="'panel-set_active'" class="mass-action-panel">
              <div class="form-group">
                <label>{{ $t('general.active') }}</label>
                <el-select
                  :key="'select-active'"
                  v-model="bulkActiveValue"
                  clearable
                  style="width: 100%"
                  :placeholder="$t('general.select')"
                  @change="onBulkActiveChange"
                >
                  <el-option :label="$t('general.active')" :value="1" />
                  <el-option :label="$t('general.inactive')" :value="0" />
                </el-select>
              </div>
            </div>

            <!-- OVERRIDE SETTINGS -->
            <div v-else-if="massAction === 'set_override_delivery'" :key="'panel-set_override_delivery'" class="mass-action-panel mass-override-panel">
              <div class="form-group product-override-group">
                <label><span>{{ $t('catalogProd.deliveryMethodsandHours') }}</span></label>
                <div>
                  <p-checkbox
                    :value="true"
                    v-model="bulkOverrideDeliveryValue"
                    @input="onBulkOverrideDeliveryToggle"
                  >{{ $t('catalogProd.overrideSettings') }}</p-checkbox>
                  <small class="text-muted">{{ $t('catalogProd.bulkOverrideDeliveryHint') }}</small>
                </div>

                <div v-if="bulkOverrideDeliveryValue === 1" class="bulk-override-schedule">
                  <div class="form-group">
                    <label>{{ $t('orders.location') }}</label>
                    <el-select
                      :key="'select-override-locations'"
                      v-model="bulkOverrideLocationTokens"
                      multiple
                      filterable
                      clearable
                      collapse-tags
                      style="width: 100%"
                      :placeholder="$t('general.all')"
                    >
                      <el-option
                        v-for="loc in locations"
                        :key="'ov-loc-' + (loc.token || loc.id)"
                        :label="loc.name"
                        :value="loc.token || loc.id"
                      />
                    </el-select>
                    <small class="text-muted">{{ $t('catalogProd.bulkOverrideLocationsHint') }}</small>
                  </div>

                  <div
                    v-for="methodKey in bulkOverrideMethodKeys"
                    :key="'ov-method-' + methodKey"
                    class="col-md-12 bulk-ov-method"
                  >
                    <h4>
                      {{ $t('settingCompany.' + methodKey) }}
                      <button
                        type="button"
                        class="btn btn-success btn-sm"
                        @click.prevent="addBulkOverrideInterval(methodKey)"
                      >+</button>
                    </h4>

                    <template v-for="(interval, intervalIdx) in (bulkOverrideDeliveryMap[methodKey] || [])">
                      <div
                        class="col-md-12"
                        :key="'ov-interval-' + methodKey + '-' + intervalIdx"
                      >
                        <p-checkbox
                          v-model="interval.active"
                          :value="interval.active"
                        >
                          {{ $t('general.active') }}
                        </p-checkbox>

                        {{ $t('general.from') }}
                        <el-time-select
                          :disabled="!interval.active"
                          placeholder="Select time"
                          v-model="interval.available_from"
                          class="in-inline-160"
                          :picker-options="bulkOverridePickerOptions"
                          popper-class="bulk-ov-time-popper"
                        />

                        {{ $t('general.to') }}
                        <el-time-select
                          :disabled="!interval.active"
                          placeholder="Select time"
                          v-model="interval.available_to"
                          class="in-inline-160"
                          :picker-options="bulkOverridePickerOptions"
                          popper-class="bulk-ov-time-popper"
                        />

                        <button
                          type="button"
                          class="btn btn-danger btn-sm"
                          @click.prevent="removeBulkOverrideInterval(methodKey, intervalIdx)"
                        >-</button>
                      </div>

                      <div
                        class="col-md-12 pull-left-first-child"
                        style="flex-wrap:wrap;"
                        :key="'ov-days-' + methodKey + '-' + intervalIdx"
                      >
                        <template v-for="(d, dayKey) in weekDays()">
                          <p-checkbox
                            :key="'ov-day-' + methodKey + '-' + intervalIdx + '-' + dayKey"
                            :disabled="!interval.active"
                            class="inline-auto mar-rt-5"
                            v-model="interval[d.toLowerCase()]"
                            :value="d"
                          >
                            {{ $t('catalogProd.' + d) }}
                          </p-checkbox>
                        </template>
                      </div>

                      <div
                        class="col-md-12 pull-left-first-child"
                        style="flex-wrap:wrap;"
                        :key="'ov-day-err-' + methodKey + '-' + intervalIdx"
                      >
                        <small
                          class="text-danger"
                          v-if="interval.active &&
                                !interval.monday &&
                                !interval.tuesday &&
                                !interval.wednesday &&
                                !interval.thursday &&
                                !interval.friday &&
                                !interval.saturday &&
                                !interval.sunday"
                        >{{ $t('validations.chooseDay') }}</small>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>

            <!-- PRICE -->
            <div v-else-if="massAction === 'adjust_price'" :key="'panel-adjust_price'" class="mass-action-panel">
              <div class="form-group">
                <label>{{ $t('catalogProd.bulkPriceDirection') }}</label>
                <el-select
                  :key="'select-price-direction'"
                  v-model="bulkPriceDirection"
                  style="width: 100%"
                  :placeholder="$t('general.select')"
                >
                  <el-option
                    v-for="opt in priceDirectionOptions"
                    :key="'price-dir-' + opt.id"
                    :label="opt.label"
                    :value="opt.id"
                  />
                </el-select>
              </div>
              <div class="form-group">
                <label>{{ $t('catalogProd.bulkPriceMode') }}</label>
                <el-select
                  :key="'select-price-mode'"
                  v-model="bulkPriceMode"
                  style="width: 100%"
                  :placeholder="$t('general.select')"
                >
                  <el-option
                    v-for="opt in priceModeOptions"
                    :key="'price-mode-' + opt.id"
                    :label="opt.label"
                    :value="opt.id"
                  />
                </el-select>
              </div>
              <div class="form-group">
                <label>{{ $t('catalogProd.bulkPriceAmount') }}</label>
                <input
                  type="number"
                  class="form-control"
                  v-model.number="bulkPriceAmount"
                  min="0"
                  step="0.01"
                  :placeholder="$t('catalogProd.bulkPriceAmount')"
                />
                <small class="text-muted">{{ $t('catalogProd.bulkPriceBaseOnlyHint') }}</small>
              </div>
            </div>

            <!-- OPTION GROUPS -->
            <div v-else-if="massAction === 'option_groups'" :key="'panel-option_groups'" class="mass-action-panel">
              <div class="form-group">
                <label>{{ $t('catalogProd.groupOption') }}</label>
                <el-select
                  :key="'select-option-groups'"
                  v-model="bulkGroupOptionIds"
                  multiple
                  collapse-tags
                  filterable
                  clearable
                  style="width: 100%"
                  :placeholder="$t('general.select')"
                >
                  <el-option
                    v-for="grp in groupOptionsList"
                    :key="'grp-' + grp.id"
                    :label="grp.name"
                    :value="grp.id"
                  />
                </el-select>
              </div>
              <div class="form-group">
                <label>{{ $t('catalogProd.bulkOptionGroupsMode') }}</label>
                <el-select
                  :key="'select-option-groups-mode'"
                  v-model="bulkOptionGroupsMode"
                  style="width: 100%"
                  :placeholder="$t('general.select')"
                >
                  <el-option
                    v-for="opt in optionGroupsModeOptions"
                    :key="'grp-mode-' + opt.id"
                    :label="opt.label"
                    :value="opt.id"
                  />
                </el-select>
                <small class="text-muted">{{ $t('catalogProd.bulkOptionGroupsModeHint') }}</small>
              </div>
            </div>

            <!-- VAT -->
            <div v-else-if="massAction === 'set_vat'" :key="'panel-set_vat'" class="mass-action-panel">
              <div class="form-group">
                <label>{{ $t('catalogCateg.vat') }}</label>
                <el-select
                  :key="'select-vat'"
                  v-model="bulkVatId"
                  filterable
                  clearable
                  style="width: 100%"
                  :placeholder="$t('vat.selectVat')"
                >
                  <el-option
                    v-for="vat in vatSelectOptions"
                    :key="'vat-' + vat.id"
                    :label="vat.label"
                    :value="vat.id"
                  />
                </el-select>
              </div>
            </div>

            <!-- SECTION -->
            <div v-else-if="massAction === 'set_section'" :key="'panel-set_section'" class="mass-action-panel">
              <div class="form-group">
                <label>{{ $t('kds.section') }}</label>
                <el-select
                  :key="'select-section'"
                  v-model="bulkSectionId"
                  filterable
                  clearable
                  style="width: 100%"
                  :placeholder="$t('general.select')"
                >
                  <el-option
                    v-for="section in kdsSections"
                    :key="'section-' + section.id"
                    :label="section.name"
                    :value="section.id"
                  />
                </el-select>
              </div>
            </div>

            <!-- DELETE -->
            <div v-else-if="massAction === 'delete'" :key="'panel-delete'" class="mass-action-panel">
              <div class="mass-delete-warning">
                {{ $t('catalogProd.bulkDeleteWarning', { count: affectedProductCount }) }}
              </div>
              <div class="form-group" style="margin-top: 14px;">
                <label class="checkbox-inline">
                  <input type="checkbox" v-model="bulkDeleteEnabled" />
                  {{ $t('catalogProd.bulkDeleteEnableLabel') }}
                </label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="button-group">
              <a
                href="#"
                class="btn btn-danger btn-icon btn btn mar-rt-10 delete"
                @click.prevent="closeMassUpdateModal"
              >
                <img src="/static/img/icons/icon-close.png">
                {{ $t('general.cancel') }}
              </a>
              <button
                type="button"
                class="btn btn-icon btn-success btn mar-rt-10 save"
                :disabled="!massConfirmEnabled || bulkUpdating"
                @click="confirmMassUpdate"
              >
                <img src="/static/img/icons/save.png">
                {{ $t('general.confirm') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {Input, Select, Option, TimeSelect} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import ProductForm from './ProductForm.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  function normalizeFilterValue (value) {
    if (!Array.isArray(value)) return []
    return value.map(v => (typeof v === 'object' && v !== null ? v.id : v))
  }

  function createEmptyBulkOverrideInterval (deliveryMethod) {
    return {
      active: false,
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false,
      delivery_method: deliveryMethod,
      available_from: '',
      available_to: ''
    }
  }

  Vue.use(Input)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(TimeSelect)
  Vue.use(DataTables)
  export default{
    components: {
      PSwitch,
      ProductForm
    },
    computed: {
      affectedProductCount () {
        if (this.selectAllMatching) {
          return Math.max(0, (this.paginationDef.totalRecords || 0) - this.exceptionProductIds.length)
        }
        return this.selectedProductIds.length
      },
      headerCheckboxChecked () {
        return this.selectAllMatching && this.exceptionProductIds.length === 0
      },
      headerCheckboxIndeterminate () {
        if (this.selectAllMatching) {
          return this.exceptionProductIds.length > 0 && this.affectedProductCount > 0
        }
        return this.selectedProductIds.length > 0
      },
      bulkModeOptions () {
        return [
          { id: 'add', label: this.$t('catalogProd.bulkModeAdd') },
          { id: 'remove', label: this.$t('catalogProd.bulkModeRemove') }
        ]
      },
      massActionOptions () {
        return [
          { id: 'locations', label: this.$t('catalogProd.changeLocations') },
          { id: 'set_active', label: this.$t('catalogProd.bulkActionActive') },
          { id: 'adjust_price', label: this.$t('catalogProd.bulkActionPrice') },
          { id: 'set_vat', label: this.$t('catalogProd.bulkActionVat') },
          { id: 'set_section', label: this.$t('catalogProd.bulkActionSection') },
          { id: 'set_override_delivery', label: this.$t('catalogProd.overrideSettings') },
          { id: 'option_groups', label: this.$t('catalogProd.bulkActionOptionGroups') },
          { id: 'delete', label: this.$t('catalogProd.bulkActionDelete') }
        ]
      },
      vatSelectOptions () {
        // Deduplicate by amount+tax — prefer company-level rows (no location)
        const bestByKey = {}
        ;(this.vatOptionsList || []).forEach(vat => {
          const taxName = vat.tax && vat.tax.name ? vat.tax.name : ''
          const key = String(vat.amount) + '|' + String(vat.tax_id || taxName)
          const isCompanyLevel = !vat.location_id && !vat.location_token
          if (!bestByKey[key] || isCompanyLevel) {
            bestByKey[key] = {
              id: vat.id,
              label: taxName ? `${vat.amount} - ${taxName}` : `${vat.amount}`
            }
          }
        })
        return Object.keys(bestByKey).map(k => bestByKey[k])
      },
      priceDirectionOptions () {
        return [
          { id: 'increase', label: this.$t('catalogProd.bulkPriceIncrease') },
          { id: 'decrease', label: this.$t('catalogProd.bulkPriceDecrease') }
        ]
      },
      priceModeOptions () {
        return [
          { id: 'flat', label: this.$t('catalogProd.bulkPriceFlat') },
          { id: 'percent', label: this.$t('catalogProd.bulkPricePercent') }
        ]
      },
      optionGroupsModeOptions () {
        return [
          { id: 'add', label: this.$t('catalogProd.bulkModeAdd') },
          { id: 'replace', label: this.$t('catalogProd.bulkModeReplace') }
        ]
      },
      hasQueuedDelete () {
        return !!this.bulkDeleteEnabled
      },
      queuedMassActions () {
        if (this.affectedProductCount <= 0) return []

        if (this.bulkDeleteEnabled) {
          return [{ action: 'delete' }]
        }

        const queued = []
        const order = ['set_active', 'adjust_price', 'set_vat', 'set_section', 'set_override_delivery', 'option_groups', 'locations']

        const builders = {
          set_active: () => {
            if (!this.bulkActiveTouched) return null
            if (this.bulkActiveValue !== 0 && this.bulkActiveValue !== 1) return null
            return { action: 'set_active', active: this.bulkActiveValue ? 1 : 0 }
          },
          adjust_price: () => {
            if (this.bulkPriceAmount === null || this.bulkPriceAmount === '' || isNaN(this.bulkPriceAmount) || Number(this.bulkPriceAmount) < 0) {
              return null
            }
            return {
              action: 'adjust_price',
              direction: this.getBulkPriceDirectionId(),
              price_mode: this.getBulkPriceModeId(),
              amount: Number(this.bulkPriceAmount)
            }
          },
          set_vat: () => {
            const vatId = typeof this.bulkVatId === 'object' && this.bulkVatId !== null
              ? this.bulkVatId.id
              : this.bulkVatId
            if (!vatId) return null
            return { action: 'set_vat', vat_id: vatId }
          },
          set_section: () => {
            const sectionId = typeof this.bulkSectionId === 'object' && this.bulkSectionId !== null
              ? this.bulkSectionId.id
              : this.bulkSectionId
            if (!sectionId) return null
            return { action: 'set_section', kds_section_id: sectionId }
          },
          set_override_delivery: () => {
            if (!this.bulkOverrideDeliveryTouched) return null
            if (this.bulkOverrideDeliveryValue !== 0 && this.bulkOverrideDeliveryValue !== 1) return null
            const payload = {
              action: 'set_override_delivery',
              override_delivery: this.bulkOverrideDeliveryValue ? 1 : 0
            }
            if (this.bulkOverrideDeliveryValue === 1) {
              const overrideSettings = this.buildBulkOverrideSettings()
              if (!overrideSettings || !overrideSettings.length) return null
              payload.override_settings = overrideSettings
            }
            return payload
          },
          option_groups: () => {
            const ids = (this.bulkGroupOptionIds || []).map(id => (
              typeof id === 'object' && id !== null ? id.id : id
            )).filter(Boolean)
            if (!ids.length) return null
            return {
              action: 'option_groups',
              group_option_ids: ids,
              mode: this.getBulkOptionGroupsModeId()
            }
          },
          locations: () => {
            const locationTokens = (this.bulkLocationTokens || []).map(token => (
              typeof token === 'object' && token !== null ? token.token : token
            )).filter(Boolean)
            if (!locationTokens.length) return null
            return {
              action: 'locations',
              mode: this.getBulkLocationModeId(),
              location_tokens: locationTokens,
              include_all_locations: this.bulkIncludeAllLocations ? 1 : 0
            }
          }
        }

        order.forEach(key => {
          const item = builders[key]()
          if (item) queued.push(item)
        })
        return queued
      },
      massConfirmEnabled () {
        return this.queuedMassActions.length > 0
      },
      bulkOverrideMethodKeys () {
        return Object.keys(this.bulkOverrideDeliveryMap || {})
      }
    },
    data () {
      return {
        type: '',
        loaded: false,
        loading: true,
        pagerCount: 5,
        paginationDef: {
          page: null,
          totalPages: null,
          totalRecords: null,
          show: true
        },
        onInputGetProductsTimeout: null,
        search: '',
        searchId: '',
        propsToSearch: ['name', 'price', 'status'],
        tableColumns: [],
        tableData: [],
        categoryIds: [],
        groupedProducts: [],
        mainCategories: [],
        topCategories: [],
        productOptions: [],
        companyProductFilters: [],
        taxes: [],
        editedRowId: null,
        windowHeight: 0,
        tableTopHeight: 70,
        tableBottomHeight: 63,
        prodTopBarHeight: 70,
        pageTopHeight: 0,
        currency: this.$session.get('selectedCompanyData')['currency_iso'],
        showLocations: false,
        showStatus: true,
        locations: [],
        kdsSections: [],
        productFilters: [],
        measurementsUnits: [],
        language: null,
        languages: [],
        showProductFilters: false,
        locationFilter: [],
        allowedOnProductLocation: true,
        selectAllMatching: false,
        selectedProductIds: [],
        exceptionProductIds: [],
        showMassUpdateModal: false,
        massAction: 'locations',
        bulkLocationTokens: [],
        bulkLocationMode: 'add',
        bulkIncludeAllLocations: false,
        bulkActiveValue: null,
        bulkPriceDirection: 'increase',
        bulkPriceMode: 'flat',
        bulkPriceAmount: null,
        bulkGroupOptionIds: [],
        bulkOptionGroupsMode: 'add',
        bulkVatId: null,
        bulkSectionId: null,
        bulkOverrideDeliveryValue: null,
        bulkOverrideDeliveryTouched: false,
        bulkOverrideLocationTokens: [],
        bulkOverrideDeliveryMap: {},
        bulkOverridePickerOptions: {
          start: '00:00',
          step: '00:15',
          end: '23:59'
        },
        bulkActiveTouched: false,
        bulkDeleteEnabled: false,
        groupOptionsList: [],
        vatOptionsList: [],
        bulkUpdating: false,
        modelValidations: {
          price: {
            required: true,
            min_value: 0,
            max_value: 999999.99
          }
        },
        filters: [
          {
            value: '',
            prop: ['name', 'price']
          },
          {
            value: [],
            prop: ['category'],
            filterFn: (row, filter) => {
              this.$nextTick(() => {
                this.tableTopHeight = this.$refs.tableTop.clientHeight
              })
              return this.isInObject(row['category_id'], filter.value)
            }
          },
          {
            value: [],
            prop: ['location_ids'],
            filterFn: (row, filter) => {
              this.$nextTick(() => {
                this.tableTopHeight = this.$refs.tableTop.clientHeight
                // this.updateCookie()
              })
              if (row['location_ids'] === null) {
                return 1
              } else if (!row['location_ids'].length) {
                return 1
              } else {
                for (let locId of row['location_ids']) {
                  if (filter.value.indexOf(locId) !== -1) {
                    return 1
                  }
                }
              }
              return 0
            }
          },
          {
            name: 'status',
            value: [],
            filterFn: (row, filter) => {
              if (filter.value[0] && filter.value[1]) {
                return true
              }
              if (filter.value[0] === 'active') {
                if (row['active'] === 1) {
                  return true
                } else {
                  return false
                }
                // return row['active'] === 1 ? true : false
              } else { // inactiv
                if (row['active'] === 0) {
                  return true
                } else {
                  return false
                }
                // return row['active'] === 0 ? true : false
              }
            }
          },
          {
            name: 'specialPrice',
            value: [],
            filterFn: (row, filter) => {
              // dacă nu există niciun filtru selectat, afișăm toate
              if (!filter.value || !filter.value.length) {
                return true
              }

              // dacă e selectat 'discounted' și produsul este discountat
              if (filter.value.includes('discounted') && row['is_discounted']) {
                return true
              }

              // dacă e selectat 'notDiscounted' și produsul nu este discountat
              if (filter.value.includes('notDiscounted') && !row['is_discounted']) {
                return true
              }

              // altfel, nu corespunde filtrului
              return false
            }
          },
          {
            value: [],
            prop: ['top_category'],
            filterFn: (row, filter) => {
              this.$nextTick(() => {
                this.tableTopHeight = this.$refs.tableTop.clientHeight
              })
              // Check if the row's category_id is in the list of categoryIds
              return this.categoryIds.includes(row['id'])
            }
          },
          {
            name: 'override_delivery_method',
            value: [],
            prop: ['override_delivery_method']
          }
          // temporary suspended
          // {
          //   value: [],
          //   prop: ['filter_value_ids'],
          //   filterFn: (row, filter) => {
          //     // console.log(filter)
          //     // console.log(row)
          //     this.$nextTick(() => {
          //       this.tableTopHeight = this.$refs.tableTop.clientHeight
          //     })
          //     if (row['filter_value_ids'] === null) {
          //       return 1
          //     } else if (!row['filter_value_ids'].length) {
          //       return 1
          //     } else {
          //       for (let fvId of row['filter_value_ids']) {
          //         // console.log('fvId', fvId)
          //         if (filter.value.indexOf(fvId) !== -1) {
          //           return 1
          //         }
          //       }
          //     }
          //     return 0
          //   }
          // }
        ]
      }
    },
    created () {
      this.initializePage()

      this.$bus.$on('refresh', this.handleRefresh)
      this.$bus.$on('updateProductInList', this.updateList)
    },
    beforeDestroy () {
      this.$bus.$off('refresh', this.handleRefresh)
      this.$bus.$off('updateProductInList', this.updateList)
    },
    mounted () {
      this.$nextTick(() => {
        this.doHeightCalculation()

        window.addEventListener('resize', () => {
          this.doHeightCalculation()
        })
      })
    },
    methods: {
      handleRefresh (editedId) {
        this.initializePage()

        if (editedId) {
          this.editedRowId = editedId
        }
      },
      setLocations (locations) {
        this.locations = Array.isArray(locations) ? locations : []
        if (!this.isOwner()) {
          let allowedLocations
          try {
            allowedLocations = JSON.parse(this.$session.get('userDataLocations'))
          } catch (error) {
            allowedLocations = null
          }
          this.locations = this.locations.filter(location => (
            Array.isArray(allowedLocations) &&
            (allowedLocations.length === 0 || allowedLocations.includes(location.id))
          ))
        }
        this.showLocations = this.locations.length > 0
      },
      initializePage () {
        var self = this
        this.$bus.$on('doReloadProdEdit', this.doReloadProdEdit)
        this.setLocations((this.$session.get('selectedCompanyData') || {}).locations_details)
        // let filterCookie = this.$cookie.get('filter-locations')
        // if (filterCookie) {
        //   filterCookie = JSON.parse(filterCookie)
        //   this.filters[2]['value'] = filterCookie
        // }
        // temporary suspended
        // this.getFilters()

        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          inactive: 1
        }
        this.getProducts(data)
        this.currency = this.getCurrencySymbol(this.currency)
        this.apiRequest('/location/taxes', 'GET', data, function (response) {
          if (response.status === true) {
            self.taxes = response.data
          }
        })


        this.apiRequest('/measurements-units', 'GET', data, (response) => {
          if (response.status) {
            this.measurementsUnits = response.data
          }
        })

        this.apiRequest('/company-data', 'GET', data, (response) => {
          if (response.status) {
            this.languages = response.data.company.languages
            this.language = response.data.company.language
          }
        })

        this.apiRequest('/sections', 'GET', data, (response) => {
          if (response.status) {
            this.kdsSections = response.data
          }
        })

        this.apiRequest('/settings/general/' + data['company_id'], 'GET', data, function (response) {
          if (response.status === true) {
            self.productOptions = response.data[0].products_options
            if (Array.isArray(response.data[0].locations_details)) {
              self.setLocations(response.data[0].locations_details)
            }
          } else {
            swal(
              '',
              self.$t('catalogProd.couldNotFetchProductOptions'),
              'error'
            )
          }
        })
        // get main categories
        this.apiRequest('/category', 'GET', data, function (response) {
          if (response.status === true) {
            self.mainCategories = response.data
          }
        })
        this.apiRequest('/topcategory', 'GET', data, function (response) {
          if (response.status === true) {
            self.topCategories = response.data
          }
        })
        data.from_product = 1
        this.apiRequest('/filter', 'GET', data, function (response) {
          if (response.status === true) {
            self.companyProductFilters = response.data
          }
        })
        window.removeEventListener('hashchange', this.dataEvent)
        window.addEventListener('hashchange', this.dataEvent)
      },
      dataEvent () {
        if (this.$refs.prodForm) {
          this.$refs.prodForm.getData()
        }
      },
      onRowClick (row, column, event) {
        if (
          event.target.tagName.toLowerCase() === 'button' ||
          event.target.tagName.toLowerCase() === 'input' ||
          event.target.closest('.el-switch') ||
          event.target.closest('.product-select-checkbox')
        ) {
          return
        }
        // Clicking anywhere in the checkbox column toggles selection
        if (column && (column.className || '').indexOf('selection-column') !== -1) {
          this.toggleProductSelection(row.id)
          return
        }
        this.goToRecord(row, null, event)
      },
      showForm () {
        if (this.$route.path.indexOf('edit') !== -1 || this.$route.path.indexOf('add') !== -1) {
          return true
        } else {
          return false
        }
      },
      isNew () {
        if (this.$route.params.id && this.$route.params.id !== 'add') {
          this.type = this.$t('general.edit')
          return false
        } else {
          this.type = this.$t('general.add')
          return true
        }
      },
      doHeightCalculation () {
        this.windowHeight = window.innerHeight
        this.tableTopHeight = (this.$refs.tableTop && this.$refs.tableTop.clientHeight) ? this.$refs.tableTop.clientHeight : 0
        this.tableBottomHeight = (this.$refs.tableBottom && this.$refs.tableBottom.clientHeight) ? this.$refs.tableBottom.clientHeight : 0
        this.prodTopBarHeight = this.$refs.prodTopBar ? this.$refs.prodTopBar.clientHeight + 1 : 0
        if (window.innerWidth < 1200) {
          this.pageTopHeight = 75
        } else {
          this.pageTopHeight = 0
        }
      },
      filterChanges (data) {
        this.doHeightCalculation()
      },
      updateCookie () {
        // console.warn(this.locationFilter)
        // this.$cookie.set('filter-locations', JSON.stringify(this.filters[2]['value']), 30)
        // this.getData(false, false)
        this.doHeightCalculation()
      },
      goToAdd () {
        this.$router.push({
          name: 'Add Product',
          params: {
            productData: {},
            mainCategories: this.mainCategories,
            taxes: this.taxes,
            kdsSections: this.kdsSections,
            productOptions: this.productOptions,
            companyProductFilters: this.companyProductFilters,
            measurementsUnits: this.measurementsUnits,
            language: this.language,
            languages: this.languages
          }
        })

        this.$nextTick(() => {
          if (this.$refs.prodForm) {
            this.$refs.prodForm.getData()
            this.$refs.prodForm.getTrees()
          }
        })

        this.allowedOnProductLocation = true
        this.doHeightCalculation()
      },
      applyFilters () {
        this.clearProductSelection()
        this.onInput()
      },
      clearProductSelection () {
        this.selectAllMatching = false
        this.selectedProductIds = []
        this.exceptionProductIds = []
      },
      isProductSelected (id) {
        if (this.selectAllMatching) {
          return this.exceptionProductIds.indexOf(id) === -1
        }
        return this.selectedProductIds.indexOf(id) !== -1
      },
      toggleSelectAll () {
        if (this.selectAllMatching && this.exceptionProductIds.length === 0) {
          this.clearProductSelection()
          return
        }
        this.selectAllMatching = true
        this.selectedProductIds = []
        this.exceptionProductIds = []
      },
      toggleProductSelection (id) {
        if (this.selectAllMatching) {
          const idx = this.exceptionProductIds.indexOf(id)
          if (idx === -1) {
            this.exceptionProductIds.push(id)
          } else {
            this.exceptionProductIds.splice(idx, 1)
          }
          return
        }
        const idx = this.selectedProductIds.indexOf(id)
        if (idx === -1) {
          this.selectedProductIds.push(id)
        } else {
          this.selectedProductIds.splice(idx, 1)
        }
      },
      openMassUpdateModal () {
        if (this.affectedProductCount <= 0) return
        this.massAction = 'locations'
        this.bulkLocationTokens = []
        this.bulkLocationMode = 'add'
        this.bulkIncludeAllLocations = false
        this.bulkActiveValue = null
        this.bulkActiveTouched = false
        this.bulkPriceDirection = 'increase'
        this.bulkPriceMode = 'flat'
        this.bulkPriceAmount = null
        this.bulkGroupOptionIds = []
        this.bulkOptionGroupsMode = 'add'
        this.bulkVatId = null
        this.bulkSectionId = null
        this.bulkOverrideDeliveryValue = null
        this.bulkOverrideDeliveryTouched = false
        this.bulkOverrideLocationTokens = []
        this.bulkOverrideDeliveryMap = this.createBulkOverrideDeliveryMap()
        this.bulkDeleteEnabled = false
        this.showMassUpdateModal = true
        this.loadGroupOptionsForBulk()
        this.loadVatOptionsForBulk()
      },
      closeMassUpdateModal () {
        if (this.bulkUpdating) return
        this.showMassUpdateModal = false
        this.bulkLocationTokens = []
        this.bulkLocationMode = 'add'
        this.bulkIncludeAllLocations = false
        this.bulkGroupOptionIds = []
        this.bulkPriceAmount = null
        this.bulkVatId = null
        this.bulkSectionId = null
        this.bulkOverrideDeliveryValue = null
        this.bulkOverrideDeliveryTouched = false
        this.bulkOverrideLocationTokens = []
        this.bulkOverrideDeliveryMap = {}
        this.bulkActiveValue = null
        this.bulkActiveTouched = false
        this.bulkDeleteEnabled = false
      },
      isMassActionQueued (actionId) {
        return this.queuedMassActions.some(item => item.action === actionId)
      },
      onBulkActiveChange (value) {
        if (value === 0 || value === 1) {
          this.bulkActiveTouched = true
        } else {
          this.bulkActiveTouched = false
          this.bulkActiveValue = null
        }
      },
      onBulkOverrideDeliveryToggle (value) {
        const enabled = value === 1 || value === true
        this.bulkOverrideDeliveryTouched = true
        this.bulkOverrideDeliveryValue = enabled ? 1 : 0
        if (enabled && !Object.keys(this.bulkOverrideDeliveryMap || {}).length) {
          this.bulkOverrideDeliveryMap = this.createBulkOverrideDeliveryMap()
        }
      },
      getCompanyDeliveryMethodKeys () {
        const methods = []
        const pushMethod = (method) => {
          if (!method) return
          const key = String(method).toLowerCase()
          if (methods.indexOf(key) === -1) {
            methods.push(key)
          }
        }

        const allTypes = (this.$session.get('defaultData') || {}).delivery_types || {}
        if (Array.isArray(allTypes)) {
          allTypes.forEach((type) => {
            pushMethod(typeof type === 'string' ? type : (type && (type.key || type.type)))
          })
        } else if (allTypes && typeof allTypes === 'object') {
          Object.keys(allTypes).forEach(pushMethod)
        }

        ;(this.locations || []).forEach((loc) => {
          const ordering = loc && loc.ordering_management
          if (!Array.isArray(ordering)) return
          ordering.forEach((entry) => {
            pushMethod(entry && (entry.type || entry.delivery_method || entry.key))
          })
        })

        if (!methods.length) {
          return ['pick_up', 'delivery', 'eat_in']
        }
        return methods
      },
      createBulkOverrideDeliveryMap () {
        const map = {}
        this.getCompanyDeliveryMethodKeys().forEach((method) => {
          // Empty until the user adds an interval — never seed inactive DB rows.
          map[method] = []
        })
        return map
      },
      addBulkOverrideInterval (methodKey) {
        if (!this.bulkOverrideDeliveryMap[methodKey]) {
          Vue.set(this.bulkOverrideDeliveryMap, methodKey, [])
        }
        const interval = createEmptyBulkOverrideInterval(methodKey)
        interval.active = true
        this.bulkOverrideDeliveryMap[methodKey].push(interval)
      },
      removeBulkOverrideInterval (methodKey, intervalIndex) {
        if (!this.bulkOverrideDeliveryMap[methodKey]) return
        this.bulkOverrideDeliveryMap[methodKey].splice(intervalIndex, 1)
      },
      buildBulkOverrideSettings () {
        const delivery = {}
        Object.keys(this.bulkOverrideDeliveryMap || {}).forEach((methodKey) => {
          const intervals = (this.bulkOverrideDeliveryMap[methodKey] || []).filter((interval) => {
            if (!interval || !interval.active) return false
            return !!(
              interval.monday || interval.tuesday || interval.wednesday ||
              interval.thursday || interval.friday || interval.saturday || interval.sunday
            )
          }).map((interval) => ({
            active: true,
            monday: !!interval.monday,
            tuesday: !!interval.tuesday,
            wednesday: !!interval.wednesday,
            thursday: !!interval.thursday,
            friday: !!interval.friday,
            saturday: !!interval.saturday,
            sunday: !!interval.sunday,
            delivery_method: methodKey,
            available_from: interval.available_from || '00:00',
            available_to: interval.available_to || '23:59'
          }))
          if (intervals.length) {
            delivery[methodKey] = intervals
          }
        })
        if (!Object.keys(delivery).length) return []

        let locationTokens = (this.bulkOverrideLocationTokens || []).slice()
        if (!locationTokens.length) {
          locationTokens = (this.locations || []).map(loc => loc.token || loc.id).filter(Boolean)
        }
        if (!locationTokens.length) return []

        return locationTokens.map((token) => ({
          loc_id: token,
          version: 2,
          delivery: JSON.parse(JSON.stringify(delivery))
        }))
      },
      loadGroupOptionsForBulk () {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/group-options', 'GET', data, (response) => {
          if (response.status === true) {
            this.groupOptionsList = response.data || []
          }
        })
      },
      loadVatOptionsForBulk () {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/location/vat', 'GET', data, (response) => {
          if (response.status === true) {
            this.vatOptionsList = response.data || []
          }
        })
      },
      getBulkLocationModeId () {
        if (!this.bulkLocationMode) return 'add'
        return typeof this.bulkLocationMode === 'object'
          ? this.bulkLocationMode.id
          : this.bulkLocationMode
      },
      getBulkOptionGroupsModeId () {
        if (!this.bulkOptionGroupsMode) return 'add'
        return typeof this.bulkOptionGroupsMode === 'object'
          ? this.bulkOptionGroupsMode.id
          : this.bulkOptionGroupsMode
      },
      getBulkPriceDirectionId () {
        if (!this.bulkPriceDirection) return 'increase'
        return typeof this.bulkPriceDirection === 'object'
          ? this.bulkPriceDirection.id
          : this.bulkPriceDirection
      },
      getBulkPriceModeId () {
        if (!this.bulkPriceMode) return 'flat'
        return typeof this.bulkPriceMode === 'object'
          ? this.bulkPriceMode.id
          : this.bulkPriceMode
      },
      buildSidemenuFilterPayload () {
        const data = {
          search: this.search,
          id: this.searchId,
          category: normalizeFilterValue(this.filters[1].value),
          status: normalizeFilterValue(this.filters[3].value),
          specialPrice: normalizeFilterValue(this.filters[4].value),
          top_category: normalizeFilterValue(this.filters[5].value),
          override_delivery_method: normalizeFilterValue(this.filters[6].value)
        }
        const normalizedLocations = normalizeFilterValue(this.filters[2].value)
          .filter(v => v !== '' && v !== null && v !== undefined)
        if (normalizedLocations.length > 0) {
          data.location_ids = normalizedLocations
        }
        return data
      },
      getConfirmLineForAction (item, count) {
        const productsLabel = count === 1
          ? this.$t('catalogProd.bulkProductSingular')
          : this.$t('catalogProd.bulkProductPlural')
        const action = item.action

        if (action === 'locations') {
          const names = this.resolveLocationNames(item.location_tokens)
          return item.mode === 'remove'
            ? this.$t('catalogProd.bulkSummaryRemoveLocations', { count, products: productsLabel, value: names })
            : this.$t('catalogProd.bulkSummaryAddLocations', { count, products: productsLabel, value: names })
        }
        if (action === 'set_active') {
          return item.active
            ? this.$t('catalogProd.bulkSummarySetActive', { count, products: productsLabel })
            : this.$t('catalogProd.bulkSummarySetInactive', { count, products: productsLabel })
        }
        if (action === 'adjust_price') {
          const direction = item.direction
          const mode = item.price_mode
          const amount = item.amount
          const currency = this.currency || ''
          if (direction === 'increase' && mode === 'flat') {
            return this.$t('catalogProd.bulkSummaryIncreasePriceFlat', { count, products: productsLabel, amount, currency })
          }
          if (direction === 'increase' && mode === 'percent') {
            return this.$t('catalogProd.bulkSummaryIncreasePricePercent', { count, products: productsLabel, amount })
          }
          if (direction === 'decrease' && mode === 'flat') {
            return this.$t('catalogProd.bulkSummaryDecreasePriceFlat', { count, products: productsLabel, amount, currency })
          }
          return this.$t('catalogProd.bulkSummaryDecreasePricePercent', { count, products: productsLabel, amount })
        }
        if (action === 'option_groups') {
          const names = this.resolveOptionGroupNames(item.group_option_ids)
          return item.mode === 'replace'
            ? this.$t('catalogProd.bulkSummaryReplaceOptionGroups', { count, products: productsLabel, value: names })
            : this.$t('catalogProd.bulkSummaryAddOptionGroups', { count, products: productsLabel, value: names })
        }
        if (action === 'set_vat') {
          const vatLabel = this.resolveVatLabel(item.vat_id)
          return this.$t('catalogProd.bulkSummarySetVat', { count, products: productsLabel, value: vatLabel })
        }
        if (action === 'set_section') {
          const sectionName = this.resolveSectionName(item.kds_section_id)
          return this.$t('catalogProd.bulkSummarySetSection', { count, products: productsLabel, value: sectionName })
        }
        if (action === 'set_override_delivery') {
          if (!item.override_delivery) {
            return this.$t('catalogProd.bulkSummaryDisableOverride', { count, products: productsLabel })
          }
          const methodCount = (item.override_settings || []).reduce((acc, loc) => {
            const delivery = loc && loc.delivery ? loc.delivery : {}
            return acc + Object.keys(delivery).length
          }, 0)
          return this.$t('catalogProd.bulkSummaryEnableOverrideWithSchedule', {
            count,
            products: productsLabel,
            methods: methodCount
          })
        }
        if (action === 'delete') {
          return this.$t('catalogProd.bulkSummaryDelete', { count, products: productsLabel })
        }
        return this.$t('catalogProd.bulkSummaryGeneric', { count, products: productsLabel })
      },
      resolveVatLabel (vatId) {
        const match = (this.vatSelectOptions || []).find(v => String(v.id) === String(vatId))
        return match ? match.label : vatId
      },
      resolveSectionName (sectionId) {
        const match = (this.kdsSections || []).find(s => String(s.id) === String(sectionId))
        return match ? match.name : sectionId
      },
      resolveOptionGroupNames (ids) {
        const list = ids || []
        const names = list.map(id => {
          const match = (this.groupOptionsList || []).find(g => String(g.id) === String(id))
          return match ? match.name : id
        })
        return names.join(', ')
      },
      resolveLocationNames (tokens) {
        const list = tokens || []
        const names = list.map(token => {
          const match = (this.locations || []).find(l => String(l.token) === String(token) || String(l.id) === String(token))
          return match ? match.name : token
        })
        return names.join(', ')
      },
      getMassConfirmMessage (count) {
        const queued = this.queuedMassActions
        const productsLabel = count === 1
          ? this.$t('catalogProd.bulkProductSingular')
          : this.$t('catalogProd.bulkProductPlural')
        const header = this.$t('catalogProd.confirmBulkMultiple', { count, products: productsLabel })
        const items = queued
          .map(item => '<li>' + this.escapeHtml(this.getConfirmLineForAction(item, count)) + '</li>')
          .join('')
        const footer = this.$t('catalogProd.confirmBulkAreYouSure')
        return '<div class="mass-confirm-swal"><p>' + this.escapeHtml(header) + '</p><ul>' + items + '</ul><p class="mass-confirm-footer">' + this.escapeHtml(footer) + '</p></div>'
      },
      escapeHtml (value) {
        return String(value == null ? '' : value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;')
      },
      buildMassAnalyticsPayload (actions, responseData) {
        const companyId = this.$session.get('selectedCompany')
        const productIds = this.selectAllMatching
          ? []
          : this.selectedProductIds.slice(0, 50)
        const payload = {
          product_count: this.affectedProductCount,
          select_all_matching: !!this.selectAllMatching,
          action_count: actions.length,
          actions: actions,
          product_ids_sample: productIds
        }
        if (responseData) {
          payload.updated = responseData.updated != null ? responseData.updated : null
          payload.skipped = responseData.skipped != null ? responseData.skipped : null
          payload.total_matched = responseData.total_matched != null ? responseData.total_matched : null
          payload.results = responseData.results || null
        }
        return { companyId, payload }
      },
      confirmMassUpdate () {
        if (!this.massConfirmEnabled || this.affectedProductCount <= 0) return

        const self = this
        const count = this.affectedProductCount
        const hasDelete = this.hasQueuedDelete

        swal({
          html: this.getMassConfirmMessage(count),
          type: hasDelete ? 'warning' : 'question',
          showCancelButton: true,
          reverseButtons: true,
          confirmButtonText: this.$t('general.yes'),
          cancelButtonText: this.$t('general.no')
        }).then((result) => {
          if (result) {
            self.submitMassUpdate()
          }
        })
      },
      submitMassUpdate () {
        const self = this
        const actions = this.queuedMassActions.slice()
        if (!actions.length) return

        const companyId = this.$session.get('selectedCompany')
        const data = Object.assign({
          token: this.$session.get('token'),
          company_id: companyId,
          actions: actions,
          product_ids: this.selectAllMatching ? [] : this.selectedProductIds.slice(),
          exception_product_ids: this.selectAllMatching ? this.exceptionProductIds.slice() : []
        }, this.buildSidemenuFilterPayload())

        this.bulkUpdating = true
        this.apiRequest('/sidemenu-products/bulk-mass-update', 'POST', data, function (response) {
          self.bulkUpdating = false
          const analytics = self.buildMassAnalyticsPayload(actions, response.data || {})
          if (response.status) {
            self.trackAdminEvent(
              'ADMIN_PRODUCT_MASS_UPDATE',
              'product_mass',
              companyId,
              analytics.payload
            )
            const updatedCount = response.data && response.data.updated != null
              ? response.data.updated
              : null
            self.showMassUpdateModal = false
            self.clearProductSelection()
            swal({
              type: 'success',
              title: self.$t('general.success') + '!',
              text: updatedCount != null
                ? self.$t('catalogProd.bulkMassUpdated', { updated: updatedCount })
                : '',
              timer: 2500,
              showConfirmButton: false
            })
            self.getProducts()
          } else {
            const failPayload = Object.assign({}, analytics.payload, {
              error: response.errors || response.message || 'unknown'
            })
            self.trackAdminEvent(
              'ADMIN_PRODUCT_MASS_UPDATE_FAILED',
              'product_mass',
              companyId,
              failPayload
            )
            swal(
              '',
              self.$t('validations.wentWrong'),
              'error'
            )
          }
        })
      },
      onInput () {
        clearTimeout(this.onInputGetProductsTimeout)
        this.onInputGetProductsTimeout = setTimeout(() => {
          this.getProducts()
        }, 500)
      },
      handlePageChange (page) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          page: page,
          perPage: this.paginationDef.perPage
        }
        if (this.search.length >= 3) {
          data.search = this.search
        }
        this.getProducts(data)
      },
      getProducts (data) {
        this.loading = true
        var self = this

        data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          search: this.search,
          id: this.searchId,
          page: this.paginationDef.page
        }

        // categories
        data[this.filters[1].prop[0]] = normalizeFilterValue(this.filters[1].value)

        // locations - only send if not empty
        var normalizedLocations = normalizeFilterValue(this.filters[2].value).filter(v => v !== '' && v !== null && v !== undefined)
        if (normalizedLocations.length > 0) {
          data[this.filters[2].prop[0]] = normalizedLocations
        }

        data[this.filters[3].name] = normalizeFilterValue(this.filters[3].value)    // status
        data[this.filters[4].name] = normalizeFilterValue(this.filters[4].value)    // specialPrice

        // top categories
        data[this.filters[5].prop[0]] = normalizeFilterValue(this.filters[5].value)

        // delivery method
        data[this.filters[6].name] = normalizeFilterValue(this.filters[6].value)

        this.apiRequest('/sidemenu-products', 'GET', data, function (response) {
          if (response.status) {
            self.tableData = response.data.data
            self.paginationDef.page = response.data.pagination.page
            self.paginationDef.perPage = response.data.pagination.perPage
            self.paginationDef.totalPages = response.data.pagination.totalPages
            self.paginationDef.totalRecords = response.data.pagination.totalRecords

            // scroll to element
            if (!self.isNew()) {
              self.$nextTick(function () {
                let el = self.$el.getElementsByClassName('current')[0]
                var container = self.$refs.tableContainerRef
                var table = self.$refs.detailsScrollTable.$el.querySelector('.el-table__body tbody')
                var position = 1

                for (var i = 0; i < table.children.length; i++) {
                  if (table.children[i].classList.length > 1 && table.children[i].classList[1] === 'current') {
                    if (i > 1) {
                      position = i
                    }
                  }
                }
                container.scrollTo({
                  left: 0,
                  top: el.clientHeight * position,
                  behavior: 'smooth'
                })
              })
            }
            self.loaded = true
          }
          self.filterChanges()
          self.$nextTick(function () {
            self.loading = false
          })
        })
      },
      goToRecord (row, column, event) {
        if (
          (' ' + event.target.className + ' ').replace(/[\n\t]/g, ' ').includes(' doNotGoToRecord ')
        ) {
          return
        }

        this.allowedOnProductLocation = !!row.allowed_location

        // trimitem toate datele relevante prin `params`
        this.$router.push({
          name: 'Edit Product',
          params: {
            id: row.id,
            productData: row,
            mainCategories: this.mainCategories,
            taxes: this.taxes,
            kdsSections: this.kdsSections,
            productOptions: this.productOptions,
            companyProductFilters: this.companyProductFilters,
            measurementsUnits: this.measurementsUnits,
            language: this.language,
            languages: this.languages
          }
        })
      },
      updateName (index, row, e) {
        let self = this
        var data = {
          id: row.id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          price: row.price
        }
        this.apiRequest('/product/' + row.id, 'PUT', data, function (response) {
          if (response.status) {
            swal({
              type: 'success',
              title: self.$t('validations.success'),
              text: self.$t('validations.priceUpdated'),
              timer: 2000,
              showConfirmButton: false
            })

            self.$refs['savePriceBtn' + index].classList.add('success-tick')
            if (self.$refs.prodForm && parseInt(row.id) === parseInt(self.$route.params.id)) {
              self.$refs.prodForm.getData()
            }
            setTimeout(function () {
              self.$refs['savePriceBtn' + index].classList.remove('success-tick')
            }, 2000)
          } else {
            swal(
              '',
              this.$t('validations.wentWrong'),
              'error'
            )
          }
        })
      },
      switchUnavailableOff (row) {
        row.is_not_available = false
      },
      checkBanner (index, row, e) {
        var self = this

        if (row.active) {
          self.switchUnavailableOff(row)
        }

        if (!row.active) {
          var productData = {
            token: self.$session.get('token'),
            company_id: self.$session.get('selectedCompany'),
            product_id: row.id
          }

          self.apiRequest('/check-banner-has-product', 'GET', productData, function (response) {
            if (response && response.data && response.data.product_banner) {
              productData.active = false
              productData.id = response.data.banner_id
              swal({
                text: self.$t('catalogProd.disableProductUsedByBanner'),
                type: 'question',
                showCancelButton: true,
                confirmButtonText: self.$t('general.yes'),
                cancelButtonText: self.$t('general.no')
              }).then((result) => {
                if (result) {
                  self.apiRequest('/banner/' + productData.id, 'PUT', productData, function (response2) {
                    if (response2.status) {
                      self.handleActive(row)
                    }
                  })
                } else {
                  swal(
                    '',
                    self.$t('validations.wentWrong'),
                    'error'
                  )
                  row.active = !row.active
                }
              }, function (dismiss) {
                if (dismiss === 'cancel') {
                  row.active = !row.active
                }
              })
            } else {
              self.handleActive(row)
            }
          })
        } else {
          self.handleActive(row)
        }
      },
      handleActive (row) {
        let self = this
        let actionText = row.active ? self.$t('general.enable') : self.$t('general.disable')

        swal({
          text: `${self.$t('validations.doYouWantTo')} ${actionText} ${self.$t('general.product')} ${row.name}?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: self.$t('general.yes')
        }).then((result) => {
          if (result) {
            var data = {
              id: row.id,
              token: self.$session.get('token'),
              company_id: self.$session.get('selectedCompany'),
              active: !!row.active,
              is_not_available: row.is_not_available
            }
            self.apiRequest('/product/' + row.id, 'PUT', data, (response) => {
              if (response.status) {
                self.trackAdminEvent('ADMIN_PRODUCT_UPDATE', 'product', row.id, {
                  product_id: row.id,
                  name: row.name || null,
                  active: !!row.active,
                  location_ids: row.location_ids || (row.locations ? Object.keys(row.locations) : null)
                })
                self.$bus.$emit('doReloadProd', response.data[0])
                swal(
                  self.$t('general.success') + '!',
                  '',
                  'success'
                )
              } else {
                swal(
                  '',
                  self.$t('validations.wentWrong'),
                  'error'
                )
                row.active = !row.active
              }
            })
          }
        }).catch(() => {
          swal(
            '',
            self.$t('validations.wentWrong'),
            'error'
          )
          row.active = !row.active
        })
      },
      duplicateProduct (index, row, e) {
        let self = this
        var data = {
          id: row.id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/product/duplicate/' + row.id, 'POST', data, function (response) {
          if (response.status) {
            // add the new product in list aftre the current one
            let currentIdx = self.getObjectByElemKeyValue('id', row.id, self.tableData)
            if (currentIdx !== false) {
              self.tableData = self.tableData.slice(0, (parseInt(currentIdx) + 1)).concat(response.data).concat(self.tableData.slice((parseInt(currentIdx) + 1)))
              self.paginationDef.pageSize = self.tableData.length + 1
            }
          } else {
            swal(
              '',
              self.$t('validations.wentWrong'),
              'error'
            )
          }
          self.getProducts()
        })
      },
      rowClass (rowData) {
        const row = rowData.row || rowData
        return row.id === this.editedRowId ? 'highlight-row' : ''
      },
      handleDelete (label) {
        this.$refs.prodForm.handleDelete(label)
      },
      validate () {
        this.$refs.prodForm.validate()
      },
      removeFilter (filterKey, key) {
        Vue.delete(this.filters[filterKey].value, key)
        this.$nextTick(() => {
          this.tableTopHeight = this.$refs.tableTop.clientHeight
        })
      },
      updateList (id, data) {
        let idx = this.getObjectByElemKeyValue('id', parseInt(id), this.tableData)
        if (idx) {
          this.tableData[idx]['name'] = data['name']
          this.tableData[idx]['price'] = data['price']
          this.tableData[idx]['active'] = data['active']
          if (data['is_discounted'] !== undefined) {
            this.tableData[idx]['is_discounted'] = data['is_discounted']
          }
          if (data['locations'] !== undefined) {
            this.tableData[idx]['locations'] = data['locations']
          }
          if (data['delivery'] !== undefined) {
            this.tableData[idx]['delivery'] = data['delivery']
          }
        }
      },
      doReloadProdEdit () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.getProducts(data)
      }
      // productAllowedEdit (value) {
      //   console.log(value)
      //   this.allowedOnProductLocation = value
      // suspend temporary
      // getFilters () {
      //   var data = {
      //     token: this.$session.get('token'),
      //     company_id: this.$session.get('selectedCompany')
      //   }
      //   this.$nextTick(function () {
      //     this.loading = true
      //   })
      //   this.apiRequest('/filter', 'GET', data, (response) => {
      //     if (response.status === true) {
      //       this.$nextTick(() => { this.loading = false })
      //       this.productFilters = response.data
      //       if (this.productFilters.length) {
      //         this.showProductFilters = true
      //         for (let idxF in this.productFilters) {
      //           if (this.productFilters[idxF].filter_value.length) {
      //             for (let idxfV in this.productFilters[idxF].filter_value) {
      //               let filterValueId = this.productFilters[idxF].filter_value[idxfV].id
      //               this.filters[3]['value'].push(filterValueId)
      //             }
      //           }
      //         }
      //       }
      //       console.log('this is after get filters')
      //       console.log(this.filters[3]['value'])
      //     }
      //   })
      // }
    }
  }
</script>
<style scoped lang="scss">
.products .form-group {
  margin-bottom: 15px;
}
.products .product-availability {
  padding: 10px !important;
}
.filters-wrapper {
  float: left;
  width: 100%;
}
.tableInvoice .el-table .cell {
  height: 90px;
}
.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.locations-scroll-horizontal {
  max-width: 200px;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}
.btn-success:hover {
  background-color: #fff !important;
}
.location-item {
  display: inline-block;
  margin-right: 8px;
}
.left-buttons {
  display: flex;
  align-items: center;
}
.edit i {
  margin-right: 0px !important;
}
.left-buttons button{
  display: flex;
  align-items: center;
  padding-top: 10px;
}
.downl {
  background: green !important;
  max-width: fit-content !important;
}
.left-buttons el-button {
  margin-right: 10px; /* Spațiere între butoane */
}

.right-button {
  margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}

.button-group {
  display: flex; /* Folosește flexbox pentru alinierea orizontală */
  justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
    margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
    margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
.arrow-box {
  display: inline-block;
  font-size: 18px; /* mărimea săgeții */
  padding: 4px 6px;
  border: 1px solid #674BD2 !important; /* border violet */
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  user-select: none;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
  color: #674BD2; /* culoarea săgeții */
}

.arrow-box:hover {
  background-color: #674BD2 !important;
  border-color: #674BD2 !important;
  color: #fff !important; /* săgeata albă la hover */
}

/* Dropdown menu */
.custom-dropdown-menu {
  min-width: 180px;
  font-size: 14px;
}
.el-pagination {
  text-align: center !important;
}
/* v-select multiple tags styling */
.form-group .vs__selected-options {
  flex-wrap: nowrap;
  overflow: hidden;
}
.form-group .vs__selected {
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.product-select-checkbox {
  cursor: pointer;
  width: 16px;
  height: 16px;
  margin: 0;
  vertical-align: middle;
  flex-shrink: 0;
}
.products >>> .selection-column .cell {
  display: flex !important;
  align-items: center;
  justify-content: center;
  height: 50px !important;
  min-height: 50px;
  padding: 0 !important;
  box-sizing: border-box;
  cursor: pointer;
}
.products >>> .el-table__header .selection-column .cell {
  display: flex !important;
  align-items: center;
  justify-content: center;
  height: 50px !important;
  min-height: 50px;
  padding: 0 !important;
  box-sizing: border-box;
}
.products >>> .selection-column {
  padding: 0 !important;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mass-update-modal {
  width: 960px;
  max-width: calc(100vw - 40px);
  height: 820px;
  max-height: 90vh;
  margin: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
}
.mass-update-modal .modal-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}
.mass-update-modal .modal-header {
  padding: 20px 20px 10px 20px;
  border-bottom: 1px solid #ebeef5;
  position: relative;
  flex: 0 0 auto;
}
.mass-update-modal .modal-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}
.mass-update-modal .mass-count-badge {
  color: #674BD2;
  font-weight: 700;
}
.mass-update-modal .mass-subtitle {
  margin: 6px 0 0;
  font-size: 13px;
  color: #909399;
}
.mass-update-modal .close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 16px;
}
.mass-update-modal .modal-body {
  padding: 20px;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}
.mass-action-pills {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  margin-bottom: 18px;
  overflow-x: auto;
  padding-bottom: 4px;
}
.mass-action-pill {
  border: 1px solid #dcdfe6;
  background: #f5f7fa;
  color: #606266;
  border-radius: 20px;
  padding: 6px 12px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s, color 0.15s;
  white-space: nowrap;
  flex: 0 0 auto;
}
.mass-action-pill:hover {
  border-color: #674BD2;
  color: #674BD2;
}
.mass-action-pill.active {
  background: #674BD2;
  border-color: #674BD2;
  color: #fff;
}
.mass-action-pill.queued:not(.active) {
  border-color: #67c23a;
  color: #67c23a;
  background: #f0f9eb;
}
.mass-action-pill.danger.active {
  background: #e74c3c;
  border-color: #e74c3c;
  color: #fff;
}
.mass-pill-check {
  margin-right: 4px;
  font-size: 11px;
}
.mass-action-panel .form-group {
  margin-bottom: 14px;
}
.mass-action-panel .text-muted {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
}
.mass-delete-warning {
  background: #fef0f0;
  border: 1px solid #fbc4c4;
  color: #c0392b;
  border-radius: 6px;
  padding: 12px 14px;
  font-size: 13px;
  line-height: 1.4;
}
.mass-override-panel .product-override-group {
  margin-bottom: 8px;
  clear: both;
}
.bulk-override-schedule {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #ebeef5;
}
.bulk-ov-method {
  float: none;
  width: 100%;
  padding: 0;
  margin-bottom: 8px;
}
.bulk-ov-method h4 {
  margin: 12px 0 8px;
  font-size: 16px;
  font-weight: 600;
  color: #2c2c54;
}
.bulk-ov-method h4 .btn-sm {
  margin-left: 8px;
  vertical-align: middle;
}
.bulk-ov-method > .col-md-12 {
  float: none;
  width: 100%;
  padding: 0;
  margin-bottom: 6px;
}
.mass-override-panel .text-muted {
  display: block;
  margin-top: 6px;
  line-height: 1.4;
}
.mass-override-panel .pull-left-first-child {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.mass-update-modal .modal-footer {
  padding: 15px 20px 20px;
  border-top: 1px solid #ebeef5;
  display: flex;
  justify-content: space-between;
  flex: 0 0 auto;
}
.mass-update-modal .modal-footer .button-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.mass-update-modal .modal-footer .btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.right-group .btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
<style lang="scss">
.mass-confirm-swal {
  text-align: left !important;
}
.mass-confirm-swal p {
  margin: 0 0 10px;
  font-weight: 600;
  text-align: left;
}
.mass-confirm-swal ul {
  margin: 0;
  padding-left: 22px;
  text-align: left;
  list-style-type: disc;
}
.mass-confirm-swal li {
  display: list-item;
  margin: 6px 0;
  line-height: 1.45;
  text-align: left;
}
.mass-confirm-swal .mass-confirm-footer {
  margin: 14px 0 0;
  font-weight: 600;
}
</style>
<style lang="scss">
  span.el-checkbox__label {
    text-transform: capitalize;
  }
  .bulk-ov-time-popper {
    z-index: 10050 !important;
  }
  .mass-update-modal .modal-body {
    overflow-x: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Products/ProductsList.vue